const packageJson = require('../../package.json');

export const environment = {
    production: false,
    serverUrl: 'https://plataforma.techlead.com.br/',
    version: packageJson.version,
    name: 'dev',
    systemName: packageJson.name,
    ssoRealmName: 'integracao',
    ssoClientId: 'frontend',
    ssoBaseUrl: 'https://sso.techlead.com.br/sso-dev/'
};
